module.exports = __webpack_public_path__ + "img/feiji.6da26ead.png";